import React, { forwardRef, useState, useImperativeHandle, useRef, createRef } from "react";
import { Input } from "../../components/Input";
import { Agent } from "../../components/Agent";
import { Occupants } from "../../components/Occupants";
import { MultipleEmails } from "../../components/MultipleEmails";
import { Box, Button, Container, Typography } from "@mui/material";
import { Note } from "../../components/Note";
import { PersonName } from "../../components/PersonName";
import { Address } from "../../components/Address";
import { Income } from "../../components/Income";
import { Payment } from "../../components/PaymentGateway";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import { PreQualificationResult } from "../../components/PreQualificationResult";
import { PlaidIncomeLink } from "../../components/PlaidIncomeLink";
import { FinancialAccount } from "../../components/FinancialAccount";
import { PlaidInstruction } from "../../components/PlaidInstruction";
import { IdentityVerification } from "../../components/IdentityVerification";
import { Pets } from "../../components/Pets";
import { MultiplePerson } from "../../components/MultiplePerson";

const Steps = forwardRef((props, ref) => {
    const { handleFormData, getFormData, paymentMessage, stepValues, handleNextClick, userDetailsRecord } = props;
    const [failedIDV, setFailedIDV] = useState(false);
    const creditScoreOptionRef = useRef();
    const householdIncomeRef = useRef();
    const filedBankruptcyOptionRef = useRef();
    const evictedOptionRef = useRef();
    const refusedToPayRentRef = useRef();
    const convictedRef = useRef();
    const applicantRef = useRef();
    const coApplicantRef = useRef();
    const guarantorsRef = useRef();
    const guarantorsDataRef = useRef();
    const personNameRef = useRef();
    const occupantsOptionRef = useRef();
    const dobRef = useRef();
    const anyAdditionalResidentsOptionRef = useRef();
    const marketOptionRef = useRef();
    const addressRef = useRef();
    const incomeRef = useRef();
    const phoneRef = useRef();
    const ssnRef = useRef();
    const preferredMoveInDateOptionRef = useRef();
    const paymentRef = useRef();
    const financialAccountRef = useRef();

    const agentRef = useRef();
    const occupantRef = useRef();
    const agentOptionRef = useRef();
    const currentMonthlyRentRef = useRef();
    const additionalMonthlyExpensesRef = useRef();

    const ackRef1 = useRef();
    const ackRef2 = useRef();
    const ackRef3 = useRef();
    const ackRef4 = useRef();
    const ackRef5 = useRef();

    const confirmationRef1 = useRef();
    const confirmationRef2 = useRef();

    const petsOptionRef = useRef();
    const petRef = useRef();

    const [couponCode, setCouponCode] = useState("");
    const [couponCodeValid, setCouponCodeValid] = useState(false);
    const couponCodeRef = useRef();

    const anyAdditionalResidentsOption = [
        {
            value: "Yes",
            label: "Yes",
        },
        {
            value: "No",
            label: "No",
        },
    ];

    const marketOption = [
        {
            value: "Atlanta, GA",
            label: "Atlanta, GA",
        },
        {
            value: "Carolinas",
            label: "Carolinas",
        },
        {
            value: "Orlando, FL",
            label: "Orlando, FL",
        },
        {
            value: "Phoenix, AZ",
            label: "Phoenix, AZ",
        },
        {
            value: "Tampa, FL",
            label: "Tampa, FL",
        },
        {
            value: "Dallas-Fort Worth, TX",
            label: "Dallas-Fort Worth, TX",
        },
        {
            value: "Other",
            label: "Other",
        },
    ];

    const agentOption = [
        {
            value: "no",
            label: "No",
            subheading: "I want pathway to pair me with one, if  approved",
            componentOnSelect: "",
        },
        {
            value: "yes",
            label: "Yes",
            subheading: "I am working with a licensed real state agent",
            componentOnSelect: <Agent ref={agentRef} onChange={handleFormData} value={getFormData()}></Agent>,
        },
    ];

    const occupantsOption = [
        {
            value: "No",
            label: "No",
            componentOnSelect: "",
        },
        {
            value: "Yes",
            label: "Yes",
            componentOnSelect: (
                <Occupants
                    ref={occupantRef}
                    onChange={(value) => handleFormData("occupants", value)}
                    values={getFormData("occupants") ? getFormData("occupants") : ""}
                    isRequired={true}></Occupants>
            ),
        },
    ];

    const petsOption = [
        {
            value: "No",
            label: "No",
            componentOnSelect: "",
        },
        {
            value: "Yes",
            label: "Yes",
            componentOnSelect: (
                <Pets
                    ref={petRef}
                    onChange={(value) => handleFormData("pets", value)}
                    values={getFormData("pets") ? getFormData("pets") : ""}
                    isRequired={true}></Pets>
            ),
        },
    ];

    const creditScoreOption = [
        {
            value: "Excellent",
            label: "Excellent",
            subheading: "(740-800)",
        },
        {
            value: "Very good",
            label: "Very good",
            subheading: "(670-739)",
        },
        {
            value: "Good",
            label: "Good",
            subheading: "(620-669)",
        },
        {
            value: "Fair",
            label: "Fair",
            subheading: "(550-619)",
        },
        {
            value: "Needs work",
            label: "Needs work",
            subheading: "(500-549)",
        },
        {
            value: "Rebuilding",
            label: "Rebuilding",
            subheading: "(<500)",
        },
    ];

    const checkboxOption = [
        { value: "Yes", label: "Yes" },
        { value: "No", label: "No" },
    ];
    const validateCouponCode = () => {
        console.log("Coupon code:", getFormData("couponCode"));
        if (getFormData("couponCode") === "pathwayfreeapp") {
            handleFormData("validCoupon", true);
            setCouponCodeValid(true);
            console.log("Coupon code is valid");
        }
    };

    React.useEffect(() => {
        console.log(couponCodeValid); // Output: 'bla bla bla...'
    }, [couponCodeValid]);

    const getExistingEmailsForGuarantors = () => {
        let emails = userDetailsRecord ? [userDetailsRecord.username] : [];
        let coApplicants = getFormData("coApplicants");
        if (coApplicants?.length > 0) {
            emails = [...emails, ...coApplicants.map((item) => item.email)];
        }
        return emails;
    };

    const getExistingEmailsForCoApplicants = () => {
        let emails = userDetailsRecord ? [userDetailsRecord.username] : [];
        let guarantors = getFormData("guarantors");
        if (guarantors?.length > 0) {
            emails = [...emails, ...guarantors.map((item) => item.email)];
        }
        return emails;
    };

    const coApplicantOption = [
        { value: "No", label: "No" },
        {
            value: "Yes",
            label: "Yes",
            componentOnSelect: (
                <Box>
                    <Typography variant="body2" sx={{ marginBottom: "10px" }}>
                        Enter the email address of each adult occupant. We'll invite them to join your application and
                        provide their information.
                    </Typography>
                    <MultiplePerson
                        ref={coApplicantRef}
                        onChange={(value) => handleFormData("coApplicants", value)}
                        values={getFormData("coApplicants")}
                        buttonLabel={"Add another adult"}
                        label={"Adult"}
                        labelPostFix={"Email Address"}
                        isRequired={true}
                        min={1}
                        max={100}
                        displayRent={true}
                        applicationId={userDetailsRecord?.applicant?.applicationId}
                        existingEmails={getExistingEmailsForCoApplicants()}></MultiplePerson>
                </Box>
            ),
        },
    ];

    const guarantorOption = [
        { value: "No", label: "No" },
        {
            value: "Yes",
            label: "Yes",
            componentOnSelect: (
                <Box>
                    <Typography variant="body2" sx={{ marginBottom: "10px" }}>
                        Enter the email address of each gurantor you'd like to include in your application. We'll reach
                        out to them with more information.
                    </Typography>
                    <MultiplePerson
                        ref={guarantorsDataRef}
                        onChange={(value) => handleFormData("guarantors", value)}
                        values={getFormData("guarantors")}
                        buttonLabel={"Add guarantor"}
                        label={"Guarantor"}
                        labelPostFix={"Email Address"}
                        isRequired={true}
                        min={1}
                        max={100}
                        applicationId={userDetailsRecord?.applicant?.applicationId}
                        existingEmails={getExistingEmailsForGuarantors()}></MultiplePerson>
                </Box>
            ),
        },
    ];

    const preferredMoveInDateOption = [
        { value: "ASAP", label: "ASAP" },
        { value: "1 month", label: "1 month" },
        { value: "2-3 months", label: "2-3 months" },
        { value: "4+ months", label: "4+ months" },
        { value: "Not sure yet", label: "Not sure yet" },
    ];

    useImperativeHandle(ref, () => ({
        options,
    }));

    const handleIDVFailed = () => {
        setFailedIDV(true);
    };

    const getSSN = (value) => {
        let data =
            value?.length === 4
                ? "XXX - XX - " + value
                : value?.length === 15
                ? "XXX - XX - " + value.substr(value.length - 4)
                : value;

        return data;
    };
    const options = (userDetails, currentTab, guidance) => {
        let records = [];

        if (userDetails?.applicant?.primaryApplicant) {
            records = [
                {
                    label: "Pre-Qualification",
                    value: "application-pre-qualification",
                    heading: "Details for Pre-Qualification",

                    steps: [
                        {
                            step: "creditScore",
                            heading: "What is your credit score?",
                            helpText:
                                "Please select the range that best represents your current credit score. Your credit score is a numerical representation of your creditworthiness and may be used to determine your eligibility for certain rent-to-own programs.",
                            body: (
                                <Input
                                    type="radio"
                                    isRequired={true}
                                    ref={creditScoreOptionRef}
                                    options={creditScoreOption}
                                    onChange={(value) => handleFormData("creditScore", value)}
                                    value={getFormData("creditScore")}></Input>
                            ),
                            refs: [creditScoreOptionRef],
                            skip: currentTab && currentTab !== "application-pre-qualification",
                        },
                        {
                            step: "householdIncome",
                            heading: "What is your approximate annual household income?",
                            helpText:
                                "Enter the total combined annual income for all members of your household. This includes salaries, wages, benefits, and any other sources of income. Accurate information will help in determining the best rent-to-own options for you.",
                            body: (
                                <Input
                                    type={"number"}
                                    ref={householdIncomeRef}
                                    id="householdIncome"
                                    label="Annual Household Income"
                                    name="householdIncome"
                                    margin="normal"
                                    isRequired={true}
                                    fullWidth
                                    onChange={(value) => handleFormData("householdIncome", value)}
                                    value={getFormData("householdIncome")}
                                    prefix={"$"}></Input>
                            ),
                            refs: [householdIncomeRef],
                            skip: currentTab && currentTab !== "application-pre-qualification",
                        },
                        {
                            step: "filedBankruptcy",
                            heading: "Have you, or anyone in your household, filed for bankruptcy in the last 2 years",
                            helpText:
                                "Let us know if anyone in your household has ever filed for bankruptcy in the last 2 years. Bankruptcy details may influence some aspects of the rent-to-own process.",
                            noteHelpText:
                                "If there's specific context or details you'd like to share about this question, please leave us a note.",
                            body: (
                                <>
                                    <Box sx={{ marginBottom: "15px" }}>
                                        <Input
                                            type={"radio"}
                                            ref={filedBankruptcyOptionRef}
                                            options={checkboxOption}
                                            onChange={(value) => handleFormData("bankruptcies", value)}
                                            value={getFormData("bankruptcies")}
                                            isRequired={true}></Input>
                                    </Box>
                                    {getFormData("bankruptcies") === "Yes" && (
                                        <Box sx={{ mt: "10px" }}>
                                            <Typography variant="body2">
                                                If there's specific context or details you'd like to share about this
                                                question, please leave us a note.
                                            </Typography>
                                            <Note
                                                buttonLabel={"Add a note"}
                                                label="Add a note"
                                                inputLabel="Any additional comments (optional)"
                                                onChange={(value) => handleFormData("bankruptciesDescription", value)}
                                                value={getFormData("bankruptciesDescription")}></Note>
                                        </Box>
                                    )}
                                </>
                            ),
                            refs: [filedBankruptcyOptionRef],
                            skip: currentTab && currentTab !== "application-pre-qualification",
                        },
                        {
                            step: "evicted",
                            heading:
                                "Have you or anyone in your household ever been evicted from a tenancy or left owing money in the last 5 years?",
                            helpText:
                                "Please indicate if anyone in your household has been evicted from a property or left a rental owing money. Honest reporting ensures a smoother application process!",
                            noteHelpText:
                                "If there were circumstances around the eviction or owing money that you'd like to explain further, please leave us a note!",
                            body: (
                                <>
                                    <Box sx={{ marginBottom: "15px" }}>
                                        <Input
                                            type={"radio"}
                                            ref={evictedOptionRef}
                                            options={checkboxOption}
                                            onChange={(value) => handleFormData("evictions", value)}
                                            value={getFormData("evictions")}
                                            isRequired={true}></Input>
                                    </Box>
                                    {getFormData("evictions") === "Yes" && (
                                        <Box sx={{ mt: "10px" }}>
                                            <Typography variant="body2">
                                                If there were circumstances around the eviction or owing money that
                                                you'd like to explain further, please leave us a note!
                                            </Typography>
                                            <Note
                                                buttonLabel={"Add a note"}
                                                label="Add a note"
                                                inputLabel="Any additional comments (optional)"
                                                onChange={(value) => handleFormData("evictionsDescription", value)}
                                                value={getFormData("evictionsDescription")}></Note>
                                        </Box>
                                    )}
                                </>
                            ),
                            refs: [evictedOptionRef],
                            skip: currentTab && currentTab !== "application-pre-qualification",
                        },
                        {
                            step: "sexOffender",
                            heading: "Have you or anyone in your household ever been convicted as sex offender?",
                            helpText:
                                "Indicate if anyone in your household has ever been convicted as a sex offender. This information is important for the safety of communities and to ensure compliance with local laws and regulations.",
                            noteHelpText:
                                "If there's specific information or context you'd like to share regarding this, please leave us a note.",
                            body: (
                                <>
                                    <Box sx={{ marginBottom: "15px" }}>
                                        <Input
                                            type={"radio"}
                                            ref={refusedToPayRentRef}
                                            options={checkboxOption}
                                            onChange={(value) => handleFormData("sexOffender", value)}
                                            value={getFormData("sexOffender")}
                                            isRequired={true}></Input>
                                    </Box>
                                    {getFormData("sexOffender") === "Yes" && (
                                        <Box sx={{ mt: "10px" }}>
                                            <Typography variant="body2">
                                                If there's specific information or context you'd like to share regarding
                                                this, please leave us a note.
                                            </Typography>
                                            <Note
                                                buttonLabel={"Add a note"}
                                                label="Add a note"
                                                inputLabel="Any additional comments (optional)"
                                                onChange={(value) => handleFormData("sexOffenderDescription", value)}
                                                value={getFormData("sexOffenderDescription")}></Note>
                                        </Box>
                                    )}
                                </>
                            ),
                            refs: [refusedToPayRentRef],
                            skip: currentTab && currentTab !== "application-pre-qualification",
                        },
                        {
                            step: "ofac",
                            heading: (
                                <>
                                    Have you or anyone in your household ever been on the{" "}
                                    <a href="https://ofac.treasury.gov/about-ofac" target="_blank" rel="noreferrer">
                                        OFAC list
                                    </a>
                                    ?
                                </>
                            ),
                            helpText:
                                "The OFAC (Office of Foreign Assets Control) list contains names of individuals and companies deemed a threat to U.S. national security. Indicate if you or anyone in your household has ever been on this list.",
                            noteHelpText:
                                "If you or anyone in your household has previously been on the OFAC list and wish to provide more information or context, please click on the note button.",
                            body: (
                                <>
                                    <Box sx={{ marginBottom: "15px" }}>
                                        <Input
                                            type={"radio"}
                                            ref={convictedRef}
                                            options={checkboxOption}
                                            onChange={(value) => handleFormData("ofac", value)}
                                            value={getFormData("ofac")}
                                            isRequired={true}></Input>
                                    </Box>
                                    {getFormData("ofac") === "Yes" && (
                                        <Box sx={{ mt: "10px" }}>
                                            <Typography variant="body2">
                                                If you or anyone in your household has previously been on the OFAC list
                                                and wish to provide more information or context, please click on the
                                                note button.
                                            </Typography>
                                            <Note
                                                buttonLabel={"Add a note"}
                                                label="Add a note"
                                                inputLabel="Any additional comments (optional)"
                                                onChange={(value) => handleFormData("ofacDescription", value)}
                                                value={getFormData("ofacDescription")}></Note>
                                        </Box>
                                    )}
                                </>
                            ),
                            refs: [convictedRef],
                            skip: currentTab && currentTab !== "application-pre-qualification",
                        },
                        {
                            step: "results",
                            heading: "",
                            body: (
                                <>
                                    <PreQualificationResult stepValues={getFormData()} />
                                </>
                            ),
                            skip: currentTab && currentTab !== "application-pre-qualification",
                        },
                    ],
                },
                {
                    label: "Co-Applicants",
                    value: "application-co-applicants",
                    heading: "Tell us the co-applicants",
                    displayAsGroupingInDesktopView: true,
                    steps: [
                        {
                            step: "applicants",
                            heading: "Are there any adults that will be living with you?",
                            subheading:
                                "Anyone who will be living with you who is age 18+ will need to complete an application. If someone you are applying with has already started an application, please wait until you are invited to their application.",
                            body: (
                                <Input
                                    type="radio"
                                    ref={applicantRef}
                                    options={coApplicantOption}
                                    onChange={(value) => handleFormData("hasCoApplicant", value)}
                                    value={getFormData("hasCoApplicant")}
                                    isRequired={true}></Input>
                            ),
                            refs:
                                getFormData("hasCoApplicant") === "Yes"
                                    ? [applicantRef, coApplicantRef]
                                    : [applicantRef],
                        },
                        {
                            step: "occupants",
                            heading: "Are there any children that will be living with you?",
                            subheading:
                                "Children are under the age of 18 and won't need to complete an application, however, we need to collect some basic information for legal reasons.",
                            body: (
                                <Input
                                    type="radio"
                                    ref={occupantsOptionRef}
                                    options={occupantsOption}
                                    onChange={(value) => handleFormData("hasOccupants", value)}
                                    value={getFormData("hasOccupants")}
                                    isRequired={true}></Input>
                            ),
                            refs:
                                getFormData("hasOccupants") === "Yes"
                                    ? [occupantsOptionRef, occupantRef]
                                    : [occupantsOptionRef],
                        },
                        {
                            step: "guarantor",
                            heading: "Will you be applying with a guarantor?",
                            subheading:
                                "You will need a guarantor if your monthly household income is less than 3x the rent. A guarantor is a relative or employer of the Applicant(s) who completes an application, provides proof of 5x income coverage, has a minimum 670 credit score, and signs the lease agreement as a leaseholder. The Guarantor does not sign the option to own agreement.",
                            body: (
                                <Input
                                    type="radio"
                                    ref={guarantorsRef}
                                    options={guarantorOption}
                                    onChange={(value) => handleFormData("hasGuarantor", value)}
                                    value={getFormData("hasGuarantor")}
                                    isRequired={true}></Input>
                            ),
                            refs:
                                getFormData("hasGuarantor") === "Yes"
                                    ? [guarantorsRef, guarantorsDataRef]
                                    : [guarantorsRef],
                        },
                    ],
                },
            ];
        }

        records = [
            ...records,
            {
                label: "About",
                value: "application-about",
                heading: "Quick details about yourself",
                steps: [
                    {
                        step: "application-instruction",
                        heading: "",
                        body: <PlaidInstruction></PlaidInstruction>,
                    },
                    {
                        step: "identity-verification",
                        heading: "",
                        body: (
                            <IdentityVerification
                                onChange={(value) => handleFormData("plaidIdentityVerified", value)}
                                onFailed={handleIDVFailed}></IdentityVerification>
                        ),
                        hideFooter: failedIDV ? false : true,
                    },
                    {
                        step: "personName",
                        heading: "Let's confirm some personal details",
                        body: (
                            <PersonName
                                ref={personNameRef}
                                onChange={(value) => handleFormData("contact", value)}
                                value={getFormData("contact")}
                                isRequired={true}></PersonName>
                        ),
                        refs: [personNameRef],
                    },
                    {
                        step: "additionalInformation",
                        heading: "Provide some additional information",
                        body: (
                            <Box>
                                <Input
                                    ref={dobRef}
                                    id="dob"
                                    type="date"
                                    label={"Date of Birth (MM / DD / YYYY)"}
                                    value={getFormData("contact.dateOfBirth")}
                                    placeholder="MM / DD / YYYY"
                                    onChange={(value) => handleFormData("contact.dateOfBirth", value)}
                                    isRequired={true}
                                    mask="99 / 99 / 9999"></Input>

                                <Input
                                    ref={phoneRef}
                                    id="phone"
                                    type="maskType"
                                    margin="normal"
                                    label={"Phone Number"}
                                    value={getFormData("contact.phone")}
                                    onChange={(value) => handleFormData("contact.phone", value)}
                                    mask={"(999) 999-9999"}
                                    isRequired={true}></Input>
                                <Input
                                    ref={ssnRef}
                                    id="social-security-number"
                                    type="maskType"
                                    mask={"*** - ** - 9999"}
                                    margin="normal"
                                    label={"Social Security Number"}
                                    value={getSSN(getFormData("contact.socialSecurityNumber"))}
                                    placeholder="XXX - XX - XXXX"
                                    onChange={(value) => handleFormData("contact.socialSecurityNumber", value)}
                                    isRequired={true}></Input>
                            </Box>
                        ),
                        refs: [dobRef, phoneRef, ssnRef],
                    },
                    {
                        step: "preferredMoveInDate",
                        heading: "How soon do you want to move?",
                        body: (
                            <Input
                                type="radio"
                                ref={preferredMoveInDateOptionRef}
                                options={preferredMoveInDateOption}
                                onChange={(value) => handleFormData("preferredMoveInDate", value)}
                                value={getFormData("preferredMoveInDate")}
                                isRequired={true}></Input>
                        ),
                        refs: [preferredMoveInDateOptionRef],
                    },
                    {
                        step: "currentAddress",
                        heading: "What is your current address?",
                        body: (
                            <Address
                                ref={addressRef}
                                onChange={(value) => handleFormData("", value)}
                                value={getFormData("")}
                                isRequired={true}></Address>
                        ),
                        refs: [addressRef],
                    },
                ],
            },
        ];

        if (userDetails?.applicant?.primaryApplicant || userDetails?.applicant?.contributesToRent) {
            records = [
                ...records,
                {
                    label: "Finances",
                    value: "application-finances",
                    heading: "Tell us about your finances",
                    steps: [
                        {
                            step: "income",
                            heading: "Tell us about your income sources!",
                            body: (
                                <Income
                                    ref={incomeRef}
                                    onChange={(value) => handleFormData("incomes", value)}
                                    value={getFormData("incomes")}
                                    isRequired={true}></Income>
                            ),
                            refs: [incomeRef],
                        },
                        // {
                        //     step: "balance",
                        //     heading: "Bank Balances and Income Verification",
                        //     body: (
                        //         <FinancialAccount
                        //             ref={financialAccountRef}
                        //             onChange={(value) => handleFormData("plaidOtherVerified", value)}
                        //             handleNextClick={handleNextClick}
                        //         ></FinancialAccount>
                        //     ),
                        //     hideFooter: true,
                        //     refs: [financialAccountRef],
                        // },
                    ],
                },
            ];
        }

        if (userDetails?.applicant?.type !== "Guarantors") {
            records = [
                ...records,
                {
                    label: "Pets",
                    value: "application-pets",
                    heading: "Tell us about your pets",
                    steps: [
                        {
                            step: "pets",
                            heading: "Do you have any pets?",
                            helpText: (
                                <>
                                    We need to know if you will have any dogs or cats in the home. Learn more about our
                                    pet policy{" "}
                                    <a
                                        href="https://intercom.help/pathwayhomes/en/articles/8244325-pet-policy"
                                        target="_blank"
                                        rel="noreferrer">
                                        here
                                    </a>
                                    .
                                </>
                            ),

                            body: (
                                <Input
                                    type="radio"
                                    ref={petsOptionRef}
                                    options={petsOption}
                                    onChange={(value) => handleFormData("hasPets", value)}
                                    value={getFormData("hasPets")}
                                    isRequired={true}></Input>
                            ),
                            refs: getFormData("hasPets") === "Yes" ? [petsOptionRef, petRef] : [petsOptionRef],
                        },
                    ],
                },
            ];
        }

        records = [
            ...records,
            {
                label: "Sign",
                value: "application-sign",
                heading: "Application acknowledgements",
                steps: [
                    {
                        step: "acknowledge",
                        heading: "Please review and acknowledge the following statements:",
                        body: (
                            <>
                                <Input
                                    ref={ackRef1}
                                    id="1"
                                    type="checkbox"
                                    label={"I acknowledge that all adult residents are stated on the application."}
                                    value={getFormData("acknowledge1")}
                                    onChange={(value) => handleFormData("acknowledge1", value)}
                                    isRequired={true}></Input>

                                <Input
                                    ref={ackRef2}
                                    id="2"
                                    type="checkbox"
                                    label={
                                        "I acknowledge and agree that Pathway Homes and its property management company and their respective affiliates may provide all communications and notices to me via email delivery to the extent permitted by applicable law. I agree to the Electronic Delivery Consent."
                                    }
                                    value={getFormData("acknowledge2")}
                                    onChange={(value) => handleFormData("acknowledge2", value)}
                                    isRequired={true}></Input>
                                <Input
                                    ref={ackRef3}
                                    id="3"
                                    type="checkbox"
                                    label={
                                        "These are my written instructions and my permission for Pathway Homes to obtain my credit score and consumer reports on me, including a background check, and to check references about me. Any such reports will be used to assess my ability to pay my lease. Upon request, Pathway Homes will provide me the name and address of the consumer reporting agency that provides any consumer reports. I understand that my submission of false or incomplete information may result in the rejection of this application."
                                    }
                                    value={getFormData("acknowledge3")}
                                    onChange={(value) => handleFormData("acknowledge3", value)}
                                    isRequired={true}></Input>
                                <Input
                                    ref={ackRef4}
                                    id="4"
                                    type="checkbox"
                                    label={
                                        "I attest, under penalties of perjury that (1) I am the actual applicant(s) completing this application, (2) I have reviewed the information that I presented in the application, and (3) all information I provided is true, complete, and accurate."
                                    }
                                    value={getFormData("acknowledge4")}
                                    onChange={(value) => handleFormData("acknowledge4", value)}
                                    isRequired={true}></Input>
                                <Input
                                    ref={ackRef5}
                                    id="5"
                                    type="checkbox"
                                    label={
                                        "By checking this box and clicking “Submit” I am providing electronic consent to receive automated marketing calls and texts on behalf of Pathway Homes and it’s marketing affiliatesat the phone number you provide for purposes of receiving calls and credit offers. You understand that providing this consent is not a condition of purchasing any products or service. Your use of any product or service will be governed by the Privacy Policy and Terms of Use. You may opt out at any time by replying STOP to a text message or revoking your consent over the phone."
                                    }
                                    value={getFormData("acknowledge5")}
                                    onChange={(value) => handleFormData("acknowledge5", value)}
                                    isRequired={true}></Input>
                                <Box sx={{ mt: "10px" }}>
                                    <b>
                                        By clicking Submit, you give us permission to pull a soft inquiry credit report
                                        and background check for pre-approval purposes. This request has no impact on
                                        your credit report or score. The information derived from your background check
                                        and credit report will only be used in connection with this pre-approval.
                                    </b>
                                </Box>
                            </>
                        ),
                        refs: [ackRef1, ackRef2, ackRef3, ackRef4, ackRef5],
                    },
                ],
            },
        ];

        if (userDetails?.applicant?.primaryApplicant) {
            records = [
                ...records,
                {
                    label: "Payment",
                    value: "application-Payment",
                    hideHeading: true,
                    heading: "Payment",
                    steps: [
                        {
                            step: "payment",
                            heading: "",
                            isPaymentScreen: true,
                            body: (
                                <>
                                    <Payment ref={paymentRef} />

                                    <Box sx={{ mt: "10px" }}>
                                        <Input
                                            ref={confirmationRef1}
                                            id="1"
                                            type="checkbox"
                                            label={"I have read and understood the eligiblity requirements."}
                                            value={getFormData("payment1")}
                                            onChange={(value) => handleFormData("payment1", value)}
                                            isRequired={true}></Input>

                                        <Input
                                            ref={confirmationRef2}
                                            id="2"
                                            type="checkbox"
                                            label={
                                                "By checking this box you acknowledege that you have had the opportunity to review Path homes tenant selection criteria. The tenant selection criteria may include factors such as criminal history, credit history, current income and rental history.If you donot meet the criteria, or if you provide inaccurate or incomplete information, your application may be rejected and your application fee will be refunded."
                                            }
                                            value={getFormData("payment2")}
                                            onChange={(value) => handleFormData("payment2", value)}
                                            isRequired={true}></Input>
                                    </Box>
                                </>
                            ),
                            refs: [couponCodeRef, confirmationRef1, confirmationRef2],
                            paymentRef: couponCodeValid ? null : paymentRef,
                        },
                    ],
                },
            ];
        }

        if (userDetails?.applicant?.status === "Action Required" && guidance?.length > 0) {
            let guidanceTab = [];
            let guidanceLocation = [];
            for (let record of guidance) {
                if (record.location) {
                    let splittedRecords = record.location.split("/");
                    if (splittedRecords.length === 2) {
                        guidanceTab.push(splittedRecords[0]);
                        guidanceLocation.push(record.location);
                    }

                    if (splittedRecords.length === 3) {
                        guidanceTab.push(splittedRecords[1]);
                        guidanceLocation.push(splittedRecords[1] + "/" + splittedRecords[2]);
                    }
                }
            }

            if (guidanceTab.length > 0) {
                records = records.filter((tab) => {
                    if (guidanceTab.indexOf(tab.value) > -1) {
                        return true;
                    }
                    return false;
                });

                records = records.map((tab) => {
                    tab.steps = tab.steps.filter((step) => guidanceLocation.indexOf(tab.value + "/" + step.step) > -1);
                    return tab;
                });
            }
        }

        return records;
    };
    return <></>;
});

export { Steps };
